import React, { useEffect, useState } from 'react';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { useSelector } from 'react-redux';
import { _t } from 'utils';
import Shared from 'screens/shared';
import { ROUTE } from 'constant';
import { Paper } from '@mui/material';
import { Redirect } from 'react-router-dom';
import Groups from './groups';
import CreateForm from './create';


export default ({ user = {}, match = {}, history }) => {
  const { params = {} } = match;
  let { id } = params;
  if (!id) {
    id = user.id;
  }

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const { user: globalUser = {} } = useSelector((e) => e);
  const { properties = {} } = globalUser;
  const {
    firstname = '', lastname = '', email = '',
  } = properties;

  const [, successes] = Shared.hooks.useNotification({
    actions: [ACTIONS_TYPES.USER.DELETE],
  });

  useEffect(() => {
    actions.group.getAll();
    actions.common.setLayoutTitle({ layout: { title: _t('User'), menu: ROUTE.DASHBOARD.USER_MANAGEMENT.key } });
  }, []);

  const onDelete = (isDelete) => {
    setShowConfirmDialog(false);
    if (isDelete) {
      actions.user.delete({ id });
    }
  };

  return (
    <div className="screen-common inner-item">
      <Shared.widgets.Strap
        deleteAction={() => setShowConfirmDialog(true)}
        editAction={() => setIsUpdate(!isUpdate)}
        icon="user-tie"
        title={`${firstname} ${lastname}`}
        subTitle={email}
      />

      {/* <div className="strap" style={{ margin: '-11px -20px 15px', padding: '15px 25px' }}>
        <div className="strap-details">
          <Shared.widgets.Icon name="user-tie" style={{ fontSize: 30 }} />
          <div>
            <span style={{ display: 'block', marginLeft: 10 }} className="strap-details-title">
              {`${firstname} ${lastname}`}
            </span>
            <span
              style={{
                display: 'flex',
                fontSize: 12,
                justifyItems: 'center',
                marginLeft: 10,
              }}
            >
              {email}
            </span>
          </div>
        </div>
        <div className="strap-details-icons">
          <Shared.widgets.Icon
            name="trash"
            className="delete"
            onClick={() => setShowConfirmDialog(true)}
          />
          <Shared.widgets.Icon
            name="edit"
            className="edit"
            onClick={() => setIsUpdate(!isUpdate)}
          />
        </div>
      </div> */}

      {isUpdate && (
        <Paper style={{ marginBottom: 20, marginTop: -14 }}>
          <CreateForm isCancel onCancel={() => setIsUpdate(false)} user={globalUser} />
        </Paper>
      )}

      <Groups userId={id} history={history} />

      <Shared.dialog.Confirm show={showConfirmDialog} onClose={onDelete} />
      {!!successes.length && <Redirect to={ROUTE.DASHBOARD.USER_MANAGEMENT_USERS.path} />}
    </div>
  );
};
